import React, { PropTypes } from 'react';
import { TaggingField } from 'common/components/form_fields';

const LanguageField = ({
  input, language, languageOptions, meta
}) => (
  <TaggingField
    input={{...input, onChange: (v) => input.onChange(v || '')}}
    options={languageOptions}
    value={language}
    meta={meta}
  />
);

LanguageField.propTypes = {
  input: PropTypes.object.isRequired,
  language: PropTypes.string,
  languageOptions: PropTypes.array.isRequired,
  meta: PropTypes.object.isRequired,
};

export default LanguageField;



// WEBPACK FOOTER //
// ./profile/components/language_field.jsx